import axios from 'axios';
import api_url from '../urls';

const actions = {

  async  AddAlunos (context, value) {
      // console.log(value.grade_curricular.id)
        context.commit('PRELOADER_MUDAR',true)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
      await   axios.post(api_url.api_admin + 'addAlunos',
        {
          nome: value.nome.trim(),
          sobrenome: value.sobrenome.trim(),
          perfil_id: value.perfil_id,
          polo_id: value.polo_id,
          empresa_id:1,
          status: '1',
          doc_oficial: value.doc_oficial.trim(),
          telefone: value.telefone.trim(),
          celular:value.celular.trim(),
          email:value.email.trim(),
          data_nascimento:value.data_nascimento,
          profissao_id: value.profissao.id,
          escolaridade_id: value.escolaridade.id,
          tipo_documento_id: value.tipo_documento.id,
          sexo_id: value.sexo.id,
         // grade_curricular_id: value.ofertaGradePolo.id,
          estado_civil_id: value.estado_civil.id,
          nome_profissao: value.nome_profissao.trim(),
          nome_escolaridade: value.nome_escolaridade.trim(),
          endereco: value.endereco.trim(),
          bairro: value.bairro.trim(),
          cep: value.cep.trim(),
          numero:value.numero.trim(),
          cidade_id:value.cidade.id,
          naturalidade_id: value.naturalidade.id,
          oferta_grade_polo_id: value.ofertaGradePolo.id,

        }
        , {
            headers: {
                'authorization': AuthStr,
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            console.log(response.data)
            alert('Su registro fue realizado con éxito, un email foi enviado com los datos de acesso!')
          
        })
        .catch((error) => {
            alert(error.response.data.message)
            console.log(error.response);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
        
    },

    allAlunos (context, valor) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/allAlunos',
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
          //   console.log(response);
            context.commit('ALL_ALUNOS', response.data)
        })
        .catch((error) => {
            alert(error.response.data.message + 'Clique en salir depues revuelve a logar!')
          //  if (error.response.data.message = 'Unauthenticated.') {
               // this.$router.push({ name: 'auth/login' }) 
           // } 
          //  console.log(error.response);
        });
        
    },
    async AddMatriculaAluno (context, value) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
       await  axios.post(api_url.api_admin + 'v1/admin/AddMatriculaAluno',
        {
            aluno_id:value.aluno_id,
            oferta_grade_polo_id:value.oferta_grade_polo.id,
            status:'1',
            descricao:value.descricao
            

        },
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
          //   console.log(response);
        })
        .catch((error) => {
            alert(error.response.data.message + 'Clique en salir depues revuelve a logar!')
          //  if (error.response.data.message = 'Unauthenticated.') {
               // this.$router.push({ name: 'auth/login' }) 
           // } 
          //  console.log(error.response);
        });
        
    },
    async allMatriculaAluno (context, valor) {
        console.log(valor)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
    await  axios.get(api_url.api_admin + 'v1/admin/allmatriculaaluno/' + valor,
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
             console.log(response);
            context.commit('ALL_MATRICULA_ALUNO', response.data)
        })
        .catch((error) => {
            alert(error.response.data.message + 'Clique en salir depues revuelve a logar!')
          //  if (error.response.data.message = 'Unauthenticated.') {
               // this.$router.push({ name: 'auth/login' }) 
           // } 
          //  console.log(error.response);
        });
        
    },
    async allMatriculaAlunoPortal (context, valor) {
      console.log(valor)
      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
  await  axios.get(api_url.api_admin + 'v1/admin/allmatriculaalunoportal/' + valor,
       {
          headers: {
              'Authorization': AuthStr,
              'Content-Type': 'application/json',
              'X-Requested-With':'XMLHttpRequest',
          }
      })
      .then(response => {
           console.log(response);
          context.commit('ALL_MATRICULA_ALUNO', response.data)
      })
      .catch((error) => {
          alert(error.response.data.message + 'Clique en salir depues revuelve a logar!')
        //  if (error.response.data.message = 'Unauthenticated.') {
             // this.$router.push({ name: 'auth/login' }) 
         // } 
        //  console.log(error.response);
      });
      
  },
    getAluno (context, valor) {

            context.commit('SET_ALUNO', valor)
    
    },
    async allFaturasAluno (context, value) {
        context.commit('PRELOADER_MUDAR',true)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
    await  axios.get(api_url.api_admin + 'v1/admin/faturas_aluno/' + value,
         {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
             console.log(response);
            context.commit('ALL_FATURAS_ALUNO', response.data)
        })
        .catch((error) => {
            alert(error.response.data.message)
         
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
        
    },

    async  buscar_alunos (context, value) {
 
        context.commit('PRELOADER_MUDAR', true)
        const AuthStr = 'Bearer '.concat(localStorage.getItem('access_token'))
    
        await axios.post(api_url.api_admin + 'v1/admin/buscar_alunos',
          {
            data_inicio: value.data_inicio,
            data_fim: value.data_fim,
            polo_id: value.polo_id,
    
          },
          {
            headers: {
              'Authorization': AuthStr,
              'Content-Type': 'application/json',
            },
          })
          .then(response => {
           //  console.log(response.data)
               context.commit('ALL_ALUNOS', response.data)
          })
          .catch((error) => {
           // console.log(error)
            // console.log(error.response.data.message)
          }).finally(() => context.commit('PRELOADER_MUDAR', false))
      },
}

export default actions